export enum ExportOptions {
    CURRENT_PAGE = 'CurrentPage',
    ALL_RESULTS = 'AllResults',
    TOP = 'Top',
    SELECTED_ROWS = 'SelectedRows',
    CUSTOM = 'Custom'
}
